/* eslint-disable no-console */
import { createOTPHeaders } from '../utils/api-headers';
import { OTP_ERROR_TYPES, type OTPErrorType } from '../utils/consts';

interface IOTPCodeParams {
  email: string;
  otpChannel: string;
  sessionID: string;
  userID: string;
}

interface IOTPOptionsPayload {
  email: string;
}
// verifyOTP endpoint removed — verification handled elsewhere
export const otpService = {
  async getOTPOptions(payload: IOTPOptionsPayload, jwt: string) {
    const headers = createOTPHeaders(jwt);
    try {
      const response = await fetch('/customer/auth/v1/otp/options', {
        method: 'POST',
        headers,
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const data = await response.json();
        return { success: true, data };
      }
      console.error('Failed to fetch OTP options:', response.statusText);
      // Return specific error type for 400 status
      const errorType: OTPErrorType = response.status === 400
        ? OTP_ERROR_TYPES.MISMATCHED_DATA
        : OTP_ERROR_TYPES.GENERAL_FAILURE;
      return { success: false, error: response.statusText, errorType };

    } catch (error) {
      console.error('Error fetching OTP options:', error);
      return { success: false, error };
    }
  },

  async getOTPCode(params: IOTPCodeParams, jwt: string) {
    try {
      const response = await fetch('/customer/auth/v1/otp/get', {
        method: 'POST',
        headers: createOTPHeaders(jwt),
        body: JSON.stringify({
          email: params.email,
          otpOption: params.otpChannel
        }),
      });

      if (response.ok) {
        const data = await response.json();
        return { success: true, data };
      }
      console.error('Failed to fetch OTP code:', response.statusText);
      return { success: false, error: response.statusText };

    } catch (error) {
      console.error('Error fetching OTP code:', error);
      return { success: false, error };
    }
  },

  // verifyOTP removed — endpoint no longer used
};

export type { IOTPCodeParams, IOTPOptionsPayload };
